import { render, staticRenderFns } from "./1.priceSelection.event-registration.vue?vue&type=template&id=31331ffb"
import script from "./1.priceSelection.event-registration.vue?vue&type=script&lang=ts"
export * from "./1.priceSelection.event-registration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports